//@ts-nocheck

const discoverScroll = () => {
  const arrow = document.querySelector(".js-scroll-arrow");
  if (!arrow) {
    return;
  }
  const sections = document.querySelectorAll("section");

  arrow.addEventListener("click", () => {
    let height = sections[1].offsetTop;
    window.scrollTo({
      top: height,
      left: 0,
      behavior: "smooth",
    });
  });
};

export default discoverScroll;
